import Vue from 'vue'
import VueResource from 'vue-resource'
import { container } from '../services/container'
Vue.use(VueResource)
var jsSHA = require('jssha')

export class CachedApi {

	/**
	 * Get all widgets
	 *
	 * @param {mixed} key
	 *
	 * @return {Promise}
	 */
	get (url, params) {

		var shaObj = new jsSHA('SHA-1', 'TEXT')
		shaObj.update(JSON.stringify({url: url, params: params}))
		var hash = shaObj.getHash('HEX')

		let max = 60*5*1000

		let obj = JSON.parse(sessionStorage.getItem(hash))
		if (obj && (Date.now() - obj.time < max)) {
			return Promise.resolve().then(i => {
				return obj.response
			})
		}

		return Vue.http.get(url, {params: params, headers: {
			Authorization: 'Bearer ' + container.get('services.oauth').getToken()
		}}).then(response => {
			sessionStorage.setItem(hash, JSON.stringify({time: Date.now(), response: response}))
			return response
		})
	}

}
